import { render } from "./CampaignCategoryManageListForm.vue?vue&type=template&id=385261cd&lang=true"
import script from "./CampaignCategoryManageListForm.vue?vue&type=script&lang=js"
export * from "./CampaignCategoryManageListForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__